module.exports = __webpack_public_path__ + "img/zetianji.d8dd6473.png";